<script setup lang="ts">
const attrs = await useSekouAttr();

provide("attrs", attrs.value);
</script>

<template>
  <slot />
</template>
